import React from 'react';
import '../css/MainContent.css';
import { Link } from 'react-router-dom';
import TechScroll from './TechScroll';

const IconConsulting = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);

const IconSoftware = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
  </svg>
);

const IconAutomation = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
    <path d="M3 3v5h5"/>
    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
    <path d="M16 16h5v5"/>
  </svg>
);

const services = [
  {
    Icon: IconConsulting,
    title: 'Technology Consulting',
    description: 'We assess your operations and identify the right technology solutions to accelerate growth, reduce overhead, and eliminate friction.'
  },
  {
    Icon: IconSoftware,
    title: 'Custom Software Development',
    description: 'From web apps to enterprise platforms, we build scalable, secure software tailored precisely to your unique business workflows.'
  },
  {
    Icon: IconAutomation,
    title: 'Process Automation',
    description: 'Eliminate repetitive tasks and bottlenecks with smart automation that frees your team to focus on what drives real value.'
  }
];


const steps = [
  { num: '01', title: 'Discover', desc: 'We audit your operations, existing tools, and pain points — identifying where the right software recommendation or custom-built solution will drive the most impact.' },
  { num: '02', title: 'Design', desc: 'We architect the right solution for your needs — whether that means recommending existing software, writing custom code, or a hybrid of both — scoped to your constraints and built to scale.' },
  { num: '03', title: 'Build', desc: 'We develop iteratively with full transparency, keeping you in the loop at every milestone through launch.' },
  { num: '04', title: 'Launch', desc: 'We deploy, hand off full documentation, and stay on to ensure everything runs exactly as designed.' },
];

const MainContent = () => {
  return (
    <main>
      <section className="hero">
        <div className="hero-content">
          <div className="hero-eyebrow">
            <span className="hero-eyebrow-line" />
            <span>Technology Consulting &amp; Software Development</span>
            <span className="hero-eyebrow-line" />
          </div>
          <h1 className="hero-title">
            Engineering the Future<br />
            of <span className="accent">Your Business</span>
          </h1>
          <p className="hero-description">
            Callide partners with ambitious companies to close the gap between where they are
            and where technology can take them — from strategy to shipped software.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary">Schedule a Call &rarr;</Link>
            <Link to="/about" className="btn-secondary">Learn More</Link>
          </div>
        </div>
      </section>

      <TechScroll />

      <section className="services">
        <div className="services-container">
          <div className="section-header">
            <span className="section-label">What We Do</span>
            <h2 className="section-title">Solutions Built for Growth</h2>
            <p className="section-subtitle">
              We partner with businesses to deliver technology that creates measurable impact.
            </p>
          </div>
          <div className="services-grid">
            {services.map(({ Icon, title, description }, i) => (
              <div className="service-card" key={i}>
                <div className="service-icon"><Icon /></div>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="process">
        <div className="process-container">
          <div className="section-header">
            <span className="section-label">How We Work</span>
            <h2 className="section-title">From Brief to Launch</h2>
            <p className="section-subtitle">
              A clear, repeatable process that keeps you informed and in control at every stage.
            </p>
          </div>
          <div className="process-steps">
            {steps.map(step => (
              <div className="process-step" key={step.num}>
                <span className="step-number">{step.num}</span>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-desc">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-banner">
        <div className="cta-banner-content">
          <span className="section-label section-label-light">Get Started</span>
          <h2>Ready to Build Something That Lasts?</h2>
          <p>Let's talk about what's possible for your business.</p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary">Schedule a Call &rarr;</Link>
            <Link to="/about" className="btn-secondary">Learn About Us</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MainContent;
